// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "v2.3.5-2-g6323287-dirty",
    "hash": "g6323287",
    "distance": 2,
    "tag": "v2.3.5",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v2.3.5",
        "major": 2,
        "minor": 3,
        "patch": 5,
        "prerelease": [],
        "build": [],
        "version": "2.3.5"
    },
    "suffix": "2-g6323287-dirty",
    "semverString": "2.3.5+2.g6323287",
    "version": "0.0.0"
};
/* tslint:enable */
